import Styles from './More.module.scss'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { BottomItems } from './components/BottomItems/BottomItems'
import { MobileBottomItems } from './components/MobileBottomItems/MobileBottomItems'

export const More = () => {
  return (
    <div className={Styles.moreItemsContainer}>
      <ResponsiveDesign.Mobile>
        <MobileBottomItems />
      </ResponsiveDesign.Mobile>
      <ResponsiveDesign.Desktop>
        <BottomItems />
      </ResponsiveDesign.Desktop>
    </div>
  )
}
